// extracted by mini-css-extract-plugin
module.exports = {"clickable_label_fix":"beschikbarebeheerders_clickable_label_fix__3XlkI"};